// extracted by mini-css-extract-plugin
module.exports = {"grid":"MaterialValuesList_grid__30gLa","cellDetails":"MaterialValuesList_cellDetails__2iplI"};